var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetModuleBuilderRelationshipQuery, useLoadSystemConfigurationsQuery, useSaveRelationshipMutation, useSaveStudioLabelsMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import logger from "js-logger";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
export var RelationshipEdit = function () {
    var _a;
    var _b = useParams(), packagesName = _b.packagesName, moduleName = _b.moduleName, relationshipName = _b.relationship, fieldName = _b.fieldName, type = _b.type;
    var _c = useTranslation([
        "ModuleBuilder",
        moduleName || "common",
        "common",
        "Studio",
    ]), t = _c.t, i18n = _c.i18n;
    var _d = useSaveStudioLabelsMutation(), saveStudioLabelMutation = _d[0], saveLabel = _d[1].data;
    var _e = useLoadSystemConfigurationsQuery(null), systemData = _e.data, error = _e.error;
    var systemConfig = (systemData === null || systemData === void 0 ? void 0 : systemData.data) || {};
    var defaultLanguage = ((_a = systemConfig.languages) === null || _a === void 0 ? void 0 : _a.default) || "fr_FR" || "";
    var newRelationName = "new";
    var _f = useGetModuleBuilderRelationshipQuery({
        moduleName: moduleName,
        relationship_name: fieldName === newRelationName ? "" : fieldName === null || fieldName === void 0 ? void 0 : fieldName.replace(/\*/g, ""),
        lang: defaultLanguage,
    }), labels_relationship = _f.data, isLoadingEdit = _f.isLoading, refetch = _f.refetch;
    var labelOnly = false;
    var _g = useState({
        rel: {},
        subpanels: {},
        relatables: {},
        is_new: {},
    }), editedRelationship = _g[0], setEditedRelationship = _g[1];
    var relationshipInfo = (editedRelationship === null || editedRelationship === void 0 ? void 0 : editedRelationship.rel) || {};
    var primarySubpanels = (editedRelationship === null || editedRelationship === void 0 ? void 0 : editedRelationship.subpanels) || {};
    var relatedSubpanelLabelName = relationshipInfo.rhs_label || "";
    var primarySubpanelLabelName = (relationshipInfo === null || relationshipInfo === void 0 ? void 0 : relationshipInfo.lhs_label) || "";
    var _h = useState(""), relatedSubpanelLabel = _h[0], setRelatedSubpanelLabel = _h[1];
    var _j = useState(""), primarySubpanelLabel = _j[0], setPrimarySubpanelLabel = _j[1];
    /* useEffect(() => {
      setRelatedSubpanelLabel(
        t(relatedSubpanelLabelName, { ns: moduleName }) as string
      );
      setPrimarySubpanelLabel(
        (t(primarySubpanelLabelName, { ns: moduleName }) as string )
      );
    }, [relationshipInfo, relatedSubpanelLabelName, primarySubpanelLabelName, t]);*/
    var _k = useState(""), relationType = _k[0], setRelationType = _k[1];
    var _l = useState(""), primaryModuleName = _l[0], setPrimaryModuleName = _l[1];
    var _m = useState("default"), primarySubpanelName = _m[0], setPrimarySubpanelName = _m[1];
    var _o = useState(""), relatedModuleName = _o[0], setRelatedModuleName = _o[1];
    var _p = useState("default"), relatedSubpanelName = _p[0], setRelatedSubpanelName = _p[1];
    var _q = useState({ relationships: false, save: false }), loading = _q[0], setLoading = _q[1];
    var mbRoot = "/modules/ModuleBuilder";
    var relatedModule = (editedRelationship === null || editedRelationship === void 0 ? void 0 : editedRelationship.relatables)
        ? editedRelationship.relatables[relatedModuleName]
        : {};
    var relationshipTypes = (relatedModule === null || relatedModule === void 0 ? void 0 : relatedModule.cardinalities) || {};
    var relatedSubpanels = (relatedModule === null || relatedModule === void 0 ? void 0 : relatedModule.subpanels) || {};
    var isEditable = !relationshipInfo.id;
    var primaryDetailsVisible = ["many-to-one", "many-to-many"].includes(relationType);
    var relatedDetailsVisible = ["one-to-many", "many-to-many"].includes(relationType);
    var isLoad = loading.relationships || loading.save;
    var savableRelationship = function () {
        if (!["one-to-one", "one-to-many", "many-to-many", "many-to-one"].includes(relationType) ||
            Object.keys(relationshipTypes).length === 0 ||
            !Object.keys(relationshipTypes).includes(relationType)) {
            return false;
        }
        var relationship = __assign({}, relationshipInfo);
        relationship.relationship_name = relationshipName;
        relationship.lhs_module = primaryModuleName;
        relationship.lhs_subpanel = ["many-to-one", "many-to-many"].includes(relationType)
            ? primarySubpanelName
            : "";
        relationship.lhs_label = primarySubpanelLabel;
        relationship.rhs_module = relatedModuleName;
        relationship.rhs_subpanel = ["many-to-one", "many-to-many"].includes(relationType)
            ? relatedSubpanelName
            : "";
        relationship.rhs_label = relatedSubpanelLabel;
        relationship.relationship_type = relationType;
        return relationship;
    };
    var canSave = (editedRelationship === null || editedRelationship === void 0 ? void 0 : editedRelationship.rel) && savableRelationship();
    var loadRelationship = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, relationship;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(function (prevState) { return (__assign(__assign({}, prevState), { relationships: true })); });
                    payload = {
                        packagesName: packagesName !== "default" ? packagesName : "",
                        moduleName: moduleName,
                        relationshipName: relationshipName,
                    };
                    logger.debug("relationship = ", labels_relationship);
                    return [4 /*yield*/, (labels_relationship === null || labels_relationship === void 0 ? void 0 : labels_relationship.data)];
                case 1:
                    relationship = _a.sent();
                    setEditedRelationship(relationship);
                    setLoading(function (prevState) { return (__assign(__assign({}, prevState), { relationships: false })); });
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        loadRelationship();
    }, [moduleName, labels_relationship]);
    useEffect(function () {
        refreshFormData();
    }, [editedRelationship]);
    var refreshFormData = function () {
        var relationship = editedRelationship || {};
        var rel = relationship.rel || {};
        setPrimaryModuleName(rel.lhs_module || moduleName);
        setRelatedModuleName(rel.rhs_module || "");
        setRelationType(rel.relationship_type || "");
    };
    var _r = useSaveRelationshipMutation(), saveRelationshipMutation = _r[0], _s = _r[1], saveData = _s.data, tokenAccessError = _s.error, isLoadingSave = _s.isLoading;
    var saveRelationship = function () { return __awaiter(void 0, void 0, void 0, function () {
        var relationship, payload, result, labels, newLabels, resultLabels;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(function (prevState) { return (__assign(__assign({}, prevState), { save: true })); });
                    relationship = savableRelationship();
                    payload = {
                        package: packagesName !== "default" ? packagesName : "",
                        module: moduleName,
                        relationship: relationship,
                        labelOnly: labelOnly,
                        lang: defaultLanguage,
                        relationshipName: fieldName === null || fieldName === void 0 ? void 0 : fieldName.replace(/\*/g, ""),
                    };
                    if ((relationship.from_studio ||
                        (relationship.readonly && !editedRelationship.is_new)) &&
                        relationship.relationship_type !== "one-to-one") {
                        payload.labelOnly = true;
                    }
                    return [4 /*yield*/, saveRelationshipMutation({
                            body: payload,
                        }).unwrap()];
                case 1:
                    result = _b.sent();
                    if (!result) {
                        console.error("SAVE_RELATIONSHIP::error");
                    }
                    console.debug(result);
                    labels = (_a = {},
                        _a[primarySubpanelLabelName] = primarySubpanelLabel,
                        _a[relatedSubpanelLabelName] = relatedSubpanelLabel,
                        _a);
                    newLabels = Object.entries(labels).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return [
                            "label_" + key,
                            value,
                        ];
                    });
                    return [4 /*yield*/, saveStudioLabelMutation({
                            moduleName: moduleName,
                            body: {
                                package: packagesName,
                                lang: defaultLanguage,
                                new_labels: newLabels,
                            },
                        }).unwrap()];
                case 2:
                    resultLabels = _b.sent();
                    setLoading(function (prevState) { return (__assign(__assign({}, prevState), { save: false })); });
                    toast.success("Relationship saved");
                    // Refresh data
                    return [4 /*yield*/, loadRelationship()];
                case 3:
                    // Refresh data
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var translatedRelatedSubpanelLabel = i18n.exists("".concat(relatedSubpanelLabelName), { ns: moduleName })
            ? t("".concat(relatedSubpanelLabelName), { ns: moduleName })
            : relatedModuleName;
        var translatedPrimarySubpanelLabel = i18n.exists("".concat(primarySubpanelLabelName), { ns: moduleName })
            ? t("".concat(primarySubpanelLabelName), { ns: moduleName })
            : primaryModuleName;
        setRelatedSubpanelLabel(translatedRelatedSubpanelLabel);
        setPrimarySubpanelLabel(translatedPrimarySubpanelLabel);
    }, [
        relationshipInfo,
        relatedSubpanelLabelName,
        primarySubpanelLabelName,
        t,
        i18n,
        primaryModuleName,
        relatedModuleName,
    ]);
    var inputClassname = "ml-2 px-2 h-8 w-full border border-gray-200 rounded-sm text-sm text-gray-600 ";
    var labelClassname = "w-1/12 text-sm text-gray-600";
    return (_jsx("div", __assign({ className: "flex flex-row max-h-[50vh] overflow-y-auto" }, { children: _jsx("div", __assign({ className: "w-full p-4" }, { children: _jsx("div", __assign({ className: "" }, { children: _jsxs("div", __assign({ className: "space-y-4" }, { children: [_jsxs("div", __assign({ className: "flex space-x-2" }, { children: [_jsx("button", __assign({ className: "button primary px-4 py-2 rounded disabled:opacity-50", disabled: isLoad || !canSave, onClick: saveRelationship }, { children: t("LBL_BTN_SAVEPUBLISH", { ns: "Studio" }) })), _jsx(Link, __assign({ to: "".concat(mbRoot, "/studio/packages/").concat(packagesName, "/").concat(moduleName, "/relationships"), className: "button secondary bg-gray-500 text-white px-4 py-2 rounded" }, { children: t("LBL_BTN_CANCEL", { ns: "Studio" }) }))] })), _jsxs("div", __assign({ className: "relative" }, { children: [_jsxs("div", __assign({ className: " " }, { children: [_jsx("div", __assign({ className: "" }, { children: _jsx("label", __assign({ className: "font-medium text-sm " }, { children: t("LBL_LHS_MODULE", { ns: "ModuleBuilder" }) })) })), _jsxs("div", __assign({ className: "ml-[10%]" }, { children: [_jsxs("div", __assign({ className: "flex  flex-row" }, { children: [_jsx("label", __assign({ className: labelClassname }, { children: t("LBL_MODULE", { ns: "ModuleBuilder" }) })), _jsx("input", { className: inputClassname, type: "text", readOnly: true, value: t("".concat(primaryModuleName)) })] })), primaryDetailsVisible && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-row py-1.5" }, { children: [_jsx("label", __assign({ className: labelClassname }, { children: t("LBL_LABEL", { ns: "ModuleBuilder" }) })), _jsx("input", { value: primarySubpanelLabel, onChange: function (e) {
                                                                        return setPrimarySubpanelLabel(e.target.value);
                                                                    }, className: inputClassname, type: "text" })] })), _jsxs("div", __assign({ className: "flex flex-row py-1.5" }, { children: [_jsxs("label", __assign({ className: labelClassname }, { children: [t("LBL_SUBPANEL_FROM", { ns: "ModuleBuilder" }), " ", primaryModuleName] })), isEditable ? (_jsxs("select", __assign({ value: primarySubpanelName, onChange: function (e) {
                                                                        return setPrimarySubpanelName(e.target.value);
                                                                    }, className: inputClassname }, { children: [isLoadingEdit && (_jsx("option", { children: t("app.LBL_LOADING", { ns: "common" }) })), Object.entries(primarySubpanels).map(function (_a) {
                                                                            var subpanelKey = _a[0], subpanelName = _a[1];
                                                                            return (_jsx("option", __assign({ value: subpanelKey }, { children: subpanelName }), subpanelKey));
                                                                        })] }))) : (_jsx("input", { className: inputClassname, type: "text", readOnly: true }))] }))] })), _jsxs("div", __assign({ className: "flex flex-row py-1.5" }, { children: [_jsx("label", __assign({ className: labelClassname }, { children: t("LBL_TYPE", { ns: "ModuleBuilder" }) })), _jsxs("select", __assign({ value: relationType, onChange: function (e) { return setRelationType(e.target.value); }, className: inputClassname, disabled: !isEditable }, { children: [isLoadingEdit && (_jsx("option", { children: t("app.LBL_LOADING", { ns: "common" }) })), Object.entries(relationshipTypes).map(function (_a) {
                                                                    var relTypeKey = _a[0], relTypeLabel = _a[1];
                                                                    return (_jsx("option", __assign({ value: relTypeKey }, { children: t(relTypeLabel) }), relTypeKey));
                                                                })] }))] }))] }))] })), _jsxs("div", __assign({ className: " " }, { children: [_jsx("label", __assign({ className: "block text-sm font-medium" }, { children: t("LBL_RHS_MODULE", { ns: "ModuleBuilder" }) })), _jsxs("div", __assign({ className: "ml-[10%]" }, { children: [_jsxs("div", __assign({ className: "flex flex-row py-1.5" }, { children: [_jsx("label", __assign({ className: labelClassname }, { children: t("LBL_MODULE", { ns: "ModuleBuilder" }) })), isEditable ? (_jsxs("select", __assign({ value: relatedModuleName, onChange: function (e) { return setRelatedModuleName(e.target.value); }, className: inputClassname }, { children: [isLoadingEdit ? (_jsx("option", { children: t("app.LBL_LOADING", { ns: "common" }) })) : (_jsx("option", {})), Object.entries((editedRelationship === null || editedRelationship === void 0 ? void 0 : editedRelationship.relatables) || {}).map(function (_a) {
                                                                    var relatableKey = _a[0], relatableValue = _a[1];
                                                                    return (_jsx("option", __assign({ value: relatableKey }, { children: relatableKey }), relatableKey));
                                                                })] }))) : (_jsx("input", { className: inputClassname, type: "text", value: relatedModuleName, readOnly: true }))] })), relatedDetailsVisible && relatedModuleName && (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "flex flex-row py-1.5" }, { children: [_jsx("label", __assign({ className: labelClassname }, { children: t("LBL_LABEL", { ns: "ModuleBuilder" }) })), _jsx("input", { value: relatedSubpanelLabel, onChange: function (e) {
                                                                        return setRelatedSubpanelLabel(e.target.value);
                                                                    }, className: inputClassname, type: "text" })] })), _jsxs("div", __assign({ className: "flex flex-row py-1.5" }, { children: [_jsxs("label", __assign({ className: labelClassname }, { children: [t("LBL_SUBPANEL_FROM", { ns: "ModuleBuilder" }), relatedModuleName] })), isEditable ? (_jsxs("select", __assign({ value: relatedSubpanelName, onChange: function (e) {
                                                                        return setRelatedSubpanelName(e.target.value);
                                                                    }, className: inputClassname }, { children: [isLoadingEdit && _jsx("option", { children: "loading..." }), Object.entries(relatedSubpanels).map(function (_a) {
                                                                            var subpanelKey = _a[0], subpanelName = _a[1];
                                                                            return (_jsx("option", __assign({ value: subpanelKey }, { children: subpanelName }), subpanelKey));
                                                                        })] }))) : (_jsx("input", { className: inputClassname, type: "text", value: relatedSubpanelName, readOnly: true }))] }))] }))] }))] })), isLoadingSave && _jsx(LoaderImage, {})] }))] })) })) })) })));
};
